import { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";

import TStyle from "shared/style/tableStyle";
import DefaultButton from "shared/ui/DefaultButton";
import useLoginCookie from "shared/model/useLoginCookie";

/**
 * @Desc 시드권 현황 Page
 * @Access 없음
 *
 */
const SeedTicketStatus = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchRef = useRef();
  const [cookie, , deleteCookie] = useLoginCookie();

  const [fetchData, setFetchData] = useState([]);
  const [fetchStatus, setFetchStatus] = useState([]);

  const onClickSearch = () => {
    const searchValue = searchRef.current?.value || "";
        
        const isPhoneNumber = /^(0\d{1,2}-?\d{3,4}-?\d{4})$/.test(searchValue);

        if (isPhoneNumber) {
            setSearchParams({ 
                accountNameLike: "",
                accountContactLike: searchValue 
            });
        } else {
            setSearchParams({ 
                accountNameLike: searchValue, 
                accountContactLike: ""
            });
        }
  };

  useEffect(() => {
    const accountNameLike = searchParams.get('accountNameLike') || "";
    const accountContactLike = searchParams.get('accountContactLike') || "";
    (async () => {
      const response = await fetch(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/admin/record_seed_ticket?accountNameLike=${
          accountNameLike || ""
        }&accountContactLike=${accountContactLike || ""}`,
        {
          method: "GET",
          headers: {
            token: cookie,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        setFetchStatus(response.status);
        return;
      }

      const jsonData = await response.json();
      setFetchData(jsonData.items);
    })();
  }, [searchParams]);

  return (
    <Style.Wrapper>
      <MainHeader>시드권 현황</MainHeader>
      <Style.InputWrapper>
        <input
          placeholder={"연락처 또는 이름을 입력해주세요"}
          defaultValue={searchParams.get("accountNameLike") || ""}
          ref={searchRef}
        />
        <DefaultButton small fitWidth expandHeight clickEvent={onClickSearch}>
          검색
        </DefaultButton>
      </Style.InputWrapper>

      <TStyle.TableDiv>
        <TStyle.TableRow $title>
          {["ID", "이름", "연락처", "시드권 타입", "보유 개수"].map(
            (elem, index) => (
              <TStyle.Data $title $size={"longlonglong"} key={index}>
                {elem}
              </TStyle.Data>
            )
          )}
        </TStyle.TableRow>
        {fetchData.map((seed, index) => (
          <TStyle.TableRow
          key={index}
            $odd={index % 2 === 1}
            onClick={() => navigate(`/user/${seed?.idx}/detail`)}
          >
            <TStyle.Data $size={"longlonglong"}>{seed.accountid}</TStyle.Data>
            <TStyle.Data $size={"longlonglong"}>{seed.accountname}</TStyle.Data>
            <TStyle.Data $size={"longlonglong"}>
              {seed.accountcontact}
            </TStyle.Data>
            <TStyle.Data $size={"longlonglong"}>{seed.tickettype}</TStyle.Data>
            <TStyle.Data $size={"longlonglong"}>{seed.ticketcount}</TStyle.Data>
          </TStyle.TableRow>
        ))}
      </TStyle.TableDiv>
    </Style.Wrapper>
  );
};

export default SeedTicketStatus;
